module.exports = __webpack_public_path__ + "img/gjng2921_2.a26672e5.svg";